import { isBusy } from '@cascade/core/auth';
import { hasSession } from './Authentication.helpers.ts';
import type { TAuthenticationGateProps } from './Authentication.types.ts';
import { useAuthentication } from './use-authentication/index.ts';

export const AuthenticationGate = ({
  loading,
  unauthenticated,
  children,
}: TAuthenticationGateProps) => {
  const state = useAuthentication();

  if (hasSession(state)) {
    return children;
  }

  if (isBusy(state)) {
    return loading;
  }

  return unauthenticated;
};
